import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.Footer}>
      <p className={styles.Brand}>My Star ReadIn</p>
    </footer>
  );
}

export default Footer;
